import React from 'react';
import parse from 'html-react-parser';

import { StyledText, StyledDiv, StyledTitle } from './Common.screen.style';
import { removeBreaksAndEmptyParagraphs } from '../../../utils/removeBreaksAndEmptyParagraphs';

export interface Props {
  title: string | undefined | null;
  desc: string | null | undefined;
}

const CommonScreen: React.FunctionComponent<Props> = ({ title, desc }: Props) => {
  return (
    <StyledDiv>
      <StyledTitle>{parse(removeBreaksAndEmptyParagraphs(title ?? ''))}</StyledTitle>
      <StyledText>{parse(removeBreaksAndEmptyParagraphs(desc ?? ''))}</StyledText>
    </StyledDiv>
  );
};

export default CommonScreen;
